import React from 'react';
import styled from '@emotion/styled';
import ProgressBar from '../helpers/ProgressBar';
import Counts from './Counts';
import Support from './Support';
import RecentSupport from './RecentSupport';
import ProjectHasGoodies from './ProjectHasGoodies';
import { numberWithCommas } from '../../../../../utils';
import CountUpText from './CountUpText';
import { getTicketProgressInfo } from '../utils/TicketPickCalculation';

export default function ProjectSidebarCard({
  project,
  projectDays,
  projectSupporters,
  projectDonations,
  loadingDonations,
  getProjectDonations,
  donations,
  instaHandle,
  utmParams,
  onShowContactModal, rewardsExist, rewardsUpper
}) {
  const percentage = Math.floor(((projectDonations || 0) / project.goal) * 100);
  const percentageForTotalGoal = Math.floor(
    ((projectDonations || 0) / project?.final_goal) * 100
  );

  let progress =
    (percentage >= 100 ? percentageForTotalGoal : percentage) || 0;


  const ticketData = getTicketProgressInfo({
    project,
    tickets: rewardsUpper,
  });

  if(project.is_ticketable){
    progress = ticketData.percentage ?? 0;
  }
  const hideFundingAmounts = Boolean(project.is_patreon);

  return (
    <Wrapper>
      {!hideFundingAmounts && <TopTextWrapper>
        {project.is_ticketable ? (
          <TopTextForTicket>{ticketData.label}</TopTextForTicket>
        ) : (
          <>
            <TopTextFirst
              $isFinished={
                project.status === 'successful' || project.status === 'finished'
              }
            >
              <CountUpText
                value={projectDonations ? parseFloat(projectDonations) : 0}
                duration={1000}
                formatter={(val) => `${numberWithCommas(val.toFixed(2))} €`}
              />
            </TopTextFirst>
            <TopTextSecond>
              finanziert von{' '}
              {numberWithCommas(
                project.goal ? parseFloat(project.goal).toFixed(2) : 0
              )}{' '}
              €
            </TopTextSecond>

          </>
        )}
      </TopTextWrapper>}

      {!hideFundingAmounts && (
        <ProgressBar percentage={progress} className="progress_bar_lg" />
      )}

      <Counts
        rewards={rewardsUpper}
        rewardsExists={rewardsExist}
        project={project}
        projectDays={projectDays}
        projectSupporters={projectSupporters}
        projectDonations={projectDonations}
        instaHandle={instaHandle}
      />

      <SupportArea>
        <Support
          {...utmParams}
          projectId={project?.id}
          projectStatus={project?.status}
          donationsAverage={project?.donations_average}
          project={project}
          handleShowContactModal={onShowContactModal}
        />

        <ProjectHasGoodies project={project} rewardsExist={rewardsExist} />

        {project?.id ? (
          <RecentSupport
            project={project}
            loadingDonations={loadingDonations}
            projectId={project.id}
            getProjectDonations={getProjectDonations}
            donations={donations}
          />
        ) : null}
      </SupportArea>
    </Wrapper>
  );
}

const Wrapper = styled.div`
    padding-top: 32px;
  width: 100%;
  @media (max-width: 720px) {
    padding-top: 0px;
    margin-top: -14px;
  }
`;

const SupportArea = styled.div`
  margin-top: 12px;
`;

const TopTextWrapper = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 12px;
`

const TopTextFirst = styled.span`
  font-family: Inter, sans-serif;
  font-weight: 600;
  font-size: 30px;
  line-height: 38px;
  color: ${({ $isFinished }) => ($isFinished ? '#9dbc60' : ' #2b4212')};
  @media (max-width: 720px) {
    font-size: 24px;
    line-height: 32px;
  }
`;

const TopTextSecond = styled.span`
  font-family: Inter, sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #414651;
  @media (max-width: 720px) {
    font-size: 14px;
    line-height: 20px;
  }
`;
const TopTextForTicket = styled.span`
  /* Heading */
  height: 30px;

  /* Text xl/Semibold */
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  /* identical to box height, or 150% */
  text-align: center;

  color: #2b4212;
`;
